/**
 * MCH Cart Drawer v4
 * Minimal, Inter-typed, conditional shipping bar, always-visible "Možda ti se svidi"
 * Reads window.MCH_SHIPPING for free-delivery config (toggle + threshold)
 */
(function(){
'use strict';

var SHIP = (window.MCH_SHIPPING && typeof window.MCH_SHIPPING.threshold !== 'undefined')
  ? window.MCH_SHIPPING
  : { enabled: true, threshold: 5000 };
var THRESHOLD = parseInt(SHIP.threshold, 10) || 5000;
var SHIP_ENABLED = SHIP.enabled !== false;
var CUR = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) ? window.Shopify.currency.active : 'RSD';
var I18N = (window.MCH_I18N && window.MCH_I18N.cart) || {};
function t(key, fallback) {
  return (I18N && typeof I18N[key] !== 'undefined') ? I18N[key] : fallback;
}

function esc(s){ return String(s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;').replace(/'/g,'&#39;'); }
function fmt(n){ n = parseInt(n) || 0; return Math.round(n).toLocaleString('sr-RS'); }
// Promo discount factor — respects the configured % (settings.promo_percent via
// window.MCH_PROMO_PCT from promo-pricing.liquid); falls back to 10% if unset.
function mchFactor(){ var p = window.MCH_PROMO_PCT; p = (typeof p === 'number' && p > 0 && p < 100) ? p : 10; return (100 - p) / 100; }
function getPrice(p){
  if(typeof p.price === 'number') return p.price / 100;
  if(typeof p.price === 'string') return parseFloat(p.price);
  if(p.variants && p.variants[0]){
    var v = p.variants[0].price;
    return typeof v === 'string' ? parseFloat(v) : v / 100;
  }
  return 0;
}

var drawerEl, overlayEl;

// Upsell cache — avoid re-fetching on every cart change (was a lag source)
var upsellCache = null;
var upsellCachePromise = null;

// Pending qty-change timers (module scope so closeDrawer can flush them)
var _qtyTimers = {};

// ============================================================
// INIT
// ============================================================
function init(){
  injectHTML();
  drawerEl = document.querySelector('.cart-drawer');
  overlayEl = document.querySelector('.cart-drawer-overlay');

  if (overlayEl) overlayEl.addEventListener('click', closeDrawer);
  if (drawerEl) {
    var closeBtn = drawerEl.querySelector('.cart-drawer__close');
    var continueBtn = drawerEl.querySelector('.cart-drawer__continue');
    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
    if (continueBtn) continueBtn.addEventListener('click', function(e){ e.preventDefault(); closeDrawer(); });
  }
  document.addEventListener('keydown', function(e){
    if (e.key === 'Escape' && drawerEl && drawerEl.classList.contains('active')) closeDrawer();
  });

  // Tab focus trap
  document.addEventListener('keydown', function(e){
    if (e.key !== 'Tab' || !drawerEl || !drawerEl.classList.contains('active')) return;
    var focusable = drawerEl.querySelectorAll('button, a[href], input, [tabindex]:not([tabindex="-1"])');
    if (focusable.length === 0) return;
    var first = focusable[0], last = focusable[focusable.length - 1];
    if (e.shiftKey) {
      if (document.activeElement === first) { e.preventDefault(); last.focus(); }
    } else {
      if (document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  // Intercept add-to-cart form submissions
  document.addEventListener('submit', function(e){
    var form = e.target;
    if (!form.action || !form.action.includes('/cart/add')) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    if (btn) { btn.disabled = true; btn.dataset.origText = btn.textContent; btn.textContent = t('adding', 'Dodajem…'); }
    fetch('/cart/add.js', { method: 'POST', body: new FormData(form) })
      .then(function(r){
        if (!r.ok) {
          if (btn) { btn.textContent = t('out_of_stock', 'Rasprodato'); setTimeout(function(){ btn.textContent = btn.dataset.origText; btn.disabled = false; }, 2000); }
          throw new Error('skip');
        }
        return r.json();
      })
      .then(function(item){ if (btn) { btn.textContent = btn.dataset.origText; btn.disabled = false; } if (item) onItemAdded(item); })
      .catch(function(e){ if (e && e.message === 'skip') return; if (btn) { btn.textContent = btn.dataset.origText; btn.disabled = false; } });
  });

  // Debounce qty changes — module-level so closeDrawer() can flush pending timers
  _qtyTimers = _qtyTimers || {};

  drawerEl.addEventListener('click', function(e){
    var qtyBtn = e.target.closest('.cart-item__qty-btn');
    if (qtyBtn) {
      e.preventDefault();
      var key = qtyBtn.dataset.key;
      var delta = parseInt(qtyBtn.dataset.delta, 10);
      var numEl = qtyBtn.parentElement.querySelector('.cart-item__qty-num');
      var cur = parseInt(numEl.textContent, 10) || 1;
      var newQty = Math.max(0, cur + delta);
      numEl.textContent = newQty;
      if (newQty === 0) {
        var row = qtyBtn.closest('.cart-item');
        if (row) { row.style.opacity = '0'; row.style.transform = 'translateX(20px)'; }
      }
      if (_qtyTimers[key]) clearTimeout(_qtyTimers[key].id);
      var fire = function(){ delete _qtyTimers[key]; changeCartItem(key, newQty); };
      _qtyTimers[key] = { id: setTimeout(fire, 350), fn: fire };
      return;
    }
    var removeBtn = e.target.closest('.cart-item__remove');
    if (removeBtn) {
      e.preventDefault();
      var key2 = removeBtn.dataset.key;
      var row2 = removeBtn.closest('.cart-item');
      if (row2) { row2.style.opacity = '0'; row2.style.transform = 'translateX(20px)'; }
      setTimeout(function(){ changeCartItem(key2, 0); }, 250);
      return;
    }
    var upsellBtn = e.target.closest('.upsell-product__add');
    if (upsellBtn) {
      e.preventDefault();
      // Multi-variant: toggle the size picker rather than add anything.
      // Customer must pick a specific size before we hit /cart/add.js.
      if (upsellBtn.dataset.multi === '1') {
        var card = upsellBtn.closest('.upsell-product');
        var sizeWrap = card && card.querySelector('.upsell-product__sizes');
        if (!sizeWrap) return;
        var nowOpen = sizeWrap.hidden;
        // Close any other open pickers in the drawer (one-at-a-time UX)
        document.querySelectorAll('.upsell-product__sizes').forEach(function(w){
          if (w !== sizeWrap) w.hidden = true;
        });
        document.querySelectorAll('.upsell-product__add[data-multi="1"]').forEach(function(b){
          if (b !== upsellBtn) { b.setAttribute('aria-expanded', 'false'); b.textContent = t('add_short', 'Dodaj'); }
        });
        sizeWrap.hidden = !nowOpen;
        upsellBtn.setAttribute('aria-expanded', String(nowOpen));
        upsellBtn.textContent = nowOpen ? t('close', 'Zatvori') : t('add_short', 'Dodaj');
        return;
      }
      // Single-variant: direct add (kačket etc.).
      var vid = upsellBtn.dataset.variantId;
      if (!vid) return;
      upsellBtn.textContent = '…';
      upsellBtn.disabled = true;
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: parseInt(vid, 10), quantity: 1 }) })
        .then(function(r){
          if (!r.ok) { upsellBtn.textContent = t('out_of_stock', 'Rasprodato'); setTimeout(function(){ upsellBtn.textContent = t('add_short', 'Dodaj'); upsellBtn.disabled = false; }, 2000); throw new Error('skip'); }
          return r.json();
        })
        .then(function(){
          upsellBtn.textContent = '✓';
          upsellBtn.classList.add('added');
          upsellCache = null; upsellCachePromise = null;
          refreshFullDrawer();
        })
        .catch(function(e){ if (e && e.message === 'skip') return; upsellBtn.textContent = t('add_short', 'Dodaj'); upsellBtn.disabled = false; });
      return;
    }

    // Multi-variant size chip click → add THAT specific variant.
    var sizeBtn = e.target.closest('.upsell-product__size');
    if (sizeBtn && !sizeBtn.disabled) {
      e.preventDefault();
      var sid = sizeBtn.dataset.variantId;
      if (!sid) return;
      var sizeCard = sizeBtn.closest('.upsell-product');
      var origText = sizeBtn.textContent;
      sizeBtn.textContent = '…';
      sizeBtn.disabled = true;
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: parseInt(sid, 10), quantity: 1 }) })
        .then(function(r){
          if (!r.ok) { sizeBtn.textContent = origText; sizeBtn.disabled = false; throw new Error('skip'); }
          return r.json();
        })
        .then(function(){
          // Mark the parent card as added; redrawing the drawer happens next.
          if (sizeCard) sizeCard.classList.add('upsell-product--added');
          upsellCache = null; upsellCachePromise = null;
          refreshFullDrawer();
        })
        .catch(function(err){ if (err && err.message === 'skip') return; sizeBtn.textContent = origText; sizeBtn.disabled = false; });
    }
  });

  // Cart icon → open drawer
  document.addEventListener('click', function(e){
    var trigger = e.target.closest('.cart-drawer-trigger');
    if (!trigger) return;
    e.preventDefault(); e.stopPropagation();
    refreshFullDrawer();
    openDrawer();
  }, true);

  window.addEventListener('cart:item-added', function(e){ if (e.detail) onItemAdded(e.detail); });
}

// ============================================================
// INJECT DRAWER HTML
// ============================================================
function injectHTML(){
  var shippingHTML = SHIP_ENABLED
    ? '<div class="shipping-progress" id="shippingProgress">' +
        '<div class="shipping-progress__text" id="shippingText"></div>' +
        '<div class="shipping-progress__bar-wrap"><div class="shipping-progress__bar" id="shippingBar" style="width:0%"></div></div>' +
      '</div>'
    : '';
  document.body.insertAdjacentHTML('beforeend',
    '<div class="cart-drawer-overlay"></div>' +
    '<div class="cart-drawer" role="dialog" aria-labelledby="cartDrawerTitle" aria-modal="true">' +
      '<div class="cart-drawer__header">' +
        '<span class="cart-drawer__title" id="cartDrawerTitle">' + t('title', 'Korpa') + ' <span class="cart-drawer__count">(0)</span></span>' +
        '<button class="cart-drawer__close" aria-label="' + t('close', 'Zatvori') + '"><svg viewBox="0 0 24 24"><path d="M18 6 6 18"/><path d="m6 6 12 12"/></svg></button>' +
      '</div>' +
      shippingHTML +
      '<div class="cart-drawer__scroll">' +
        '<div class="cart-drawer__items" id="cartDrawerItems"></div>' +
        '<div class="cart-drawer__upsell" id="upsellSection" hidden>' +
          '<div class="cart-drawer__upsell-header">' +
            '<span class="cart-drawer__upsell-title">' + t('you_might_like', 'Možda ti se svidi') + '</span>' +
          '</div>' +
          '<div id="upsellProducts"></div>' +
        '</div>' +
      '</div>' +
      '<div class="cart-drawer__footer" id="cartDrawerFooter">' +
        '<div class="cart-drawer__subtotal"><span class="cart-drawer__subtotal-label">' + t('subtotal', 'Ukupno') + '</span><span class="cart-drawer__subtotal-price" id="drawerSubtotal">0 ' + CUR + '</span></div>' +
        '<div class="cart-drawer__shipping-note" id="drawerShippingNote"></div>' +
        '<a href="/checkout" class="cart-drawer__checkout-btn" id="drawerCheckoutBtn">' + t('checkout', 'Nastavi ka plaćanju') + '</a>' +
        '<a href="#" class="cart-drawer__continue">' + t('continue_shopping', 'Nastavi sa kupovinom') + '</a>' +
      '</div>' +
    '</div>'
  );
}

// ============================================================
// ON ITEM ADDED — fetch full cart, render, open
// ============================================================
function onItemAdded(addedItem){
  fetch('/cart.js')
    .then(function(r){ return r.json(); })
    .then(function(cart){
      renderCartItems(cart);
      updateShipping(cart);
      updateFooter(cart);
      updateHeaderCount(cart);
      renderUpsellSection(cart);
      openDrawer();
      setTimeout(function(){
        var el = document.querySelector('.cart-item[data-key="' + addedItem.key + '"]');
        if (el) {
          el.classList.add('cart-item--flash');
          setTimeout(function(){ el.classList.remove('cart-item--flash'); }, 800);
        }
      }, 50);
    });
}

// ============================================================
// CHANGE CART ITEM (quantity or remove)
// ============================================================
function changeCartItem(key, quantity){
  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: key, quantity: quantity })
  })
  .then(function(r){
    if (!r.ok) {
      return fetch('/cart.js').then(function(r2){ return r2.json(); }).then(function(cart){
        cart._error = t('not_enough_stock', 'Nema dovoljno na stanju');
        return cart;
      });
    }
    return r.json();
  })
  .then(function(cart){
    if (!cart || !cart.items) return;
    renderCartItems(cart);
    updateShipping(cart);
    updateFooter(cart);
    updateHeaderCount(cart);
    renderUpsellSection(cart);
    if (cart._error) {
      var toast = document.createElement('div');
      toast.className = 'cart-drawer__toast';
      toast.setAttribute('role', 'alert');
      toast.textContent = cart._error;
      drawerEl.appendChild(toast);
      setTimeout(function(){ if (toast.parentNode) toast.parentNode.removeChild(toast); }, 3000);
    }
  })
  .catch(function(){ refreshFullDrawer(); });
}

function refreshFullDrawer(){
  fetch('/cart.js')
    .then(function(r){ return r.json(); })
    .then(function(cart){
      renderCartItems(cart);
      updateShipping(cart);
      updateFooter(cart);
      updateHeaderCount(cart);
      renderUpsellSection(cart);
    });
}

// ============================================================
// RENDER CART ITEMS
// ============================================================
function renderCartItems(cart){
  var container = document.getElementById('cartDrawerItems');
  var countEl = drawerEl.querySelector('.cart-drawer__count');
  var footer = document.getElementById('cartDrawerFooter');

  if (countEl) countEl.textContent = '(' + cart.item_count + ')';

  if (!cart.items || cart.items.length === 0) {
    container.innerHTML =
      '<div class="cart-drawer__empty">' +
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor"><path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><path d="M3 6h18"/><path d="M16 10a4 4 0 0 1-8 0"/></svg>' +
        '<p>' + t('empty', 'Tvoja korpa je prazna') + '</p>' +
        '<a href="/collections/all" class="btn btn--primary">' + t('view_products', 'Pogledaj proizvode') + '</a>' +
      '</div>';
    if (footer) footer.style.display = 'none';
    return;
  }
  if (footer) footer.style.display = 'block';

  var html = '';
  cart.items.forEach(function(item){
    var img = '';
    if (item.featured_image && item.featured_image.url) img = item.featured_image.url;
    else if (item.image) img = item.image;

    var title = item.product_title || item.title;
    var variant = item.variant_title || '';
    // Use ORIGINAL (pre-discount) prices as the base so the −% display is correct
    // whether the live discount is order-level OR product-level (product discounts
    // reduce final_price, which would otherwise double-discount the shown price).
    var unitPrice = (item.original_price != null ? item.original_price : item.final_price) / 100;
    var linePrice = (item.original_line_price != null ? item.original_line_price : item.final_line_price) / 100;

    html += '<div class="cart-item" data-key="' + item.key + '">';
    html += '<a href="' + esc(item.url) + '" class="cart-item__image">';
    if (img) {
      var cartImg = img.replace(/(\.\w+)(\?|$)/, '_200x$1$2');
      html += '<img src="' + esc(cartImg) + '" alt="' + esc(title) + '" loading="lazy" width="200" height="240">';
    } else {
      html += '<span class="cart-item__image-placeholder">MCH</span>';
    }
    html += '</a>';

    html += '<div class="cart-item__info">';
    html += '<a href="' + esc(item.url) + '" class="cart-item__title">' + esc(title) + '</a>';
    if (variant) html += '<div class="cart-item__variant">' + esc(variant) + '</div>';
    if (item.quantity > 1) {
      var upRe = fmt(unitPrice) + ' ' + CUR, upSa = fmt(unitPrice * mchFactor()) + ' ' + CUR;
      html += '<div class="cart-item__unit-price">' + (window.mchDualPrice ? window.mchDualPrice(upRe, upSa) : upRe) + ' × ' + item.quantity + '</div>';
    }

    html += '<div class="cart-item__bottom">';
    html += '<div class="cart-item__qty">';
    html += '<button class="cart-item__qty-btn" data-key="' + item.key + '" data-delta="-1" aria-label="' + t('qty_less', 'Manje') + '">−</button>';
    html += '<span class="cart-item__qty-num">' + item.quantity + '</span>';
    html += '<button class="cart-item__qty-btn" data-key="' + item.key + '" data-delta="1" aria-label="' + t('qty_more', 'Više') + '">+</button>';
    html += '</div>';
    var lpRe = fmt(linePrice) + ' ' + CUR, lpSa = fmt(linePrice * mchFactor()) + ' ' + CUR;
    html += '<div class="cart-item__line-price">' + (window.mchDualPrice ? window.mchDualPrice(lpRe, lpSa) : lpRe) + '</div>';
    html += '</div>';
    html += '</div>';

    html += '<button class="cart-item__remove" data-key="' + item.key + '" aria-label="' + t('remove', 'Ukloni') + '">';
    html += '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor"><path d="M3 6h18"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/></svg>';
    html += '</button>';
    html += '</div>';
  });
  container.innerHTML = html;
}

// ============================================================
// SHIPPING PROGRESS — gated by SHIP_ENABLED
// ============================================================
function updateShipping(cart){
  if (!SHIP_ENABLED) return;
  var bar = document.getElementById('shippingBar');
  var text = document.getElementById('shippingText');
  if (!bar || !text) return;

  var total = cart.total_price / 100;
  var pct = Math.min((total / THRESHOLD) * 100, 100);
  bar.style.width = pct + '%';

  text.textContent = '';
  if (total === 0) {
    bar.classList.remove('complete');
    text.appendChild(document.createTextNode(t('free_shipping_over', 'Besplatna dostava preko') + ' '));
    var strong = document.createElement('strong');
    strong.textContent = fmt(THRESHOLD) + ' ' + CUR;
    text.appendChild(strong);
  } else if (total >= THRESHOLD) {
    bar.classList.add('complete');
    var check = document.createElement('span');
    check.className = 'shipping-progress__celebration';
    check.textContent = '✓';
    var msg = document.createElement('span');
    msg.className = 'free-ship-achieved';
    msg.textContent = t('free_shipping_achieved', 'Besplatna dostava je tvoja');
    text.append(check, msg);
  } else {
    bar.classList.remove('complete');
    var rem = THRESHOLD - total;
    var tmpl = t('add_more_for_free_shipping', 'Dodaj još {amount} za besplatnu dostavu');
    var placeholder = '{amount}';
    var idx = tmpl.indexOf(placeholder);
    var amountEl = document.createElement('span');
    amountEl.className = 'amount-remaining';
    amountEl.textContent = fmt(rem) + ' ' + CUR;
    if (idx === -1) {
      text.textContent = tmpl + ' ';
      text.appendChild(amountEl);
    } else {
      text.appendChild(document.createTextNode(tmpl.slice(0, idx)));
      text.appendChild(amountEl);
      text.appendChild(document.createTextNode(tmpl.slice(idx + placeholder.length)));
    }
  }
}

// ============================================================
// FOOTER
// ============================================================
function updateFooter(cart){
  var total = cart.total_price / 100;
  var sub = document.getElementById('drawerSubtotal');
  if (sub) {
    // Base the dual price on the REGULAR subtotal (sum of line prices), NOT
    // cart.total_price — an applied order-level code (e.g. 300k) already reduces
    // total_price, so using it here would double-discount the displayed subtotal.
    var subBase = (typeof cart.original_total_price === 'number' ? cart.original_total_price : (typeof cart.items_subtotal_price === 'number' ? cart.items_subtotal_price : cart.total_price)) / 100;
    var stRe = fmt(subBase) + ' ' + CUR, stSa = fmt(subBase * mchFactor()) + ' ' + CUR;
    if (window.mchDualPrice) sub.innerHTML = window.mchDualPrice(stRe, stSa); else sub.textContent = stRe;
  }

  var note = document.getElementById('drawerShippingNote');
  if (!note) return;
  if (SHIP_ENABLED && total >= THRESHOLD) {
    note.textContent = '✓ ' + t('free_shipping_achieved', 'Besplatna dostava je tvoja');
    note.classList.add('free-shipping');
  } else if (total > 0) {
    note.textContent = t('shipping_at_checkout', 'Dostava se računa pri plaćanju');
    note.classList.remove('free-shipping');
  } else {
    note.textContent = '';
    note.classList.remove('free-shipping');
  }
}

// ============================================================
// "MOŽDA TI SE SVIDI" — always visible (cached)
// ============================================================
function renderUpsellSection(cart){
  var section = document.getElementById('upsellSection');
  if (!section) return;
  var cartPids = (cart.items || []).map(function(i){ return i.product_id; });
  // Seed Shopify's related-products endpoint with the first cart item — without
  // a product_id the endpoint returns 422 and we end up using the fallback.
  var seedId = (cart.items && cart.items[0] && cart.items[0].product_id) || null;

  loadUpsellPool(seedId).then(function(pool){
    var products = pool.filter(function(p){ return cartPids.indexOf(p.id) === -1; }).slice(0, 3);
    if (products.length === 0) { section.hidden = true; return; }
    section.hidden = false;
    renderUpsellProducts(document.getElementById('upsellProducts'), products);
  }).catch(function(){ section.hidden = true; });
}

function loadUpsellPool(seedProductId){
  if (upsellCache) return Promise.resolve(upsellCache);
  if (upsellCachePromise) return upsellCachePromise;

  var recUrl = '/recommendations/products.json?intent=related&limit=10';
  if (seedProductId) recUrl += '&product_id=' + encodeURIComponent(seedProductId);

  upsellCachePromise = fetch(recUrl)
    .then(function(r){ return r.ok ? r.json() : { products: [] }; })
    .then(function(data){
      var products = (data.products || []).filter(function(p){ return p.available !== false; });
      if (products.length >= 3) {
        upsellCache = products;
        return products;
      }
      // Fallback to all products — keep any product with AT LEAST ONE available
      // variant (not just the first; size 8 etc. is often sold out + listed first
      // by creation date, which used to mask the entire product).
      return fetch('/products.json?limit=12').then(function(r){ return r.json(); }).then(function(d2){
        var combined = (d2.products || []).filter(function(p){
          return p.variants && p.variants.some(function(v){ return v.available; });
        });
        upsellCache = combined;
        return combined;
      });
    })
    .catch(function(){
      return fetch('/products.json?limit=12').then(function(r){ return r.json(); }).then(function(d2){
        var combined = (d2.products || []).filter(function(p){
          return p.variants && p.variants.some(function(v){ return v.available; });
        });
        upsellCache = combined;
        return combined;
      });
    });
  return upsellCachePromise;
}

function renderUpsellProducts(container, products){
  if (!container) return;
  var html = '';
  products.forEach(function(p){
    var price = getPrice(p);
    var variants = (p.variants || []).filter(function(v){ return v && v.id; });
    var availableVariants = variants.filter(function(v){ return v.available !== false; });
    // "Multi-variant" = anything with more than one purchasable variant.
    // For single-variant items (e.g. one-size kačket), keep the old direct
    // "Dodaj" → adds immediately. For multi-variant, "Dodaj" reveals an
    // inline size picker — the customer must click a chip before anything
    // is added.
    var isMulti = variants.length > 1;
    var firstAvailable = availableVariants[0] || variants[0];
    var img = p.featured_image || (p.images && p.images[0] ? (typeof p.images[0] === 'string' ? p.images[0] : p.images[0].src) : null);
    var url = p.url || ('/products/' + p.handle);

    html += '<div class="upsell-product">';
    html += '<div class="upsell-product__row">';
    html += '<a href="' + esc(url) + '" class="upsell-product__image">';
    var upsellImg = img ? img.replace(/(\.\w+)(\?|$)/, '_120x$1$2') : null;
    if (upsellImg) html += '<img src="' + esc(upsellImg) + '" alt="' + esc(p.title) + '" loading="lazy" width="120" height="140">';
    else html += '<span class="upsell-product__image-placeholder">MCH</span>';
    html += '</a>';
    html += '<div class="upsell-product__info">';
    html += '<a href="' + esc(url) + '" class="upsell-product__title">' + esc(p.title) + '</a>';
    var upsRe = fmt(price) + ' ' + CUR, upsSa = fmt(price * mchFactor()) + ' ' + CUR;
    html += '<div class="upsell-product__price">' + (window.mchDualPrice ? window.mchDualPrice(upsRe, upsSa) : upsRe) + '</div>';
    html += '</div>';
    if (isMulti) {
      html += '<button class="upsell-product__add" type="button" data-multi="1" aria-expanded="false">' + t('add_short', 'Dodaj') + '</button>';
    } else if (firstAvailable) {
      html += '<button class="upsell-product__add" type="button" data-variant-id="' + firstAvailable.id + '">' + t('add_short', 'Dodaj') + '</button>';
    } else {
      html += '<button class="upsell-product__add" type="button" disabled>' + t('out_of_stock', 'Rasprodato') + '</button>';
    }
    html += '</div>'; // end .upsell-product__row
    if (isMulti) {
      html += '<div class="upsell-product__sizes" hidden>';
      variants.forEach(function(v){
        if (v.available === false) {
          html += '<button class="upsell-product__size" type="button" disabled aria-label="' + esc(v.title) + ' rasprodato">' + esc(v.title) + '</button>';
        } else {
          html += '<button class="upsell-product__size" type="button" data-variant-id="' + v.id + '">' + esc(v.title) + '</button>';
        }
      });
      html += '</div>';
    }
    html += '</div>';
  });
  container.innerHTML = html;
}

// ============================================================
// HELPERS
// ============================================================
function updateHeaderCount(cart){
  document.querySelectorAll('.cart-count').forEach(function(el){
    el.textContent = cart.item_count;
    el.style.display = cart.item_count > 0 ? 'flex' : 'none';
  });
}

var _cartTriggerEl = null;

function openDrawer(){
  _cartTriggerEl = document.activeElement;
  drawerEl.classList.add('active');
  overlayEl.classList.add('active');
  if (window.mchLockScroll) window.mchLockScroll('cart'); else document.body.style.overflow = 'hidden';
  var closeFocus = drawerEl.querySelector('.cart-drawer__close');
  if (closeFocus) setTimeout(function(){ closeFocus.focus(); }, 100);
}

function closeDrawer(){
  drawerEl.classList.remove('active');
  overlayEl.classList.remove('active');
  if (window.mchUnlockScroll) window.mchUnlockScroll('cart'); else document.body.style.overflow = '';
  // Flush any pending qty-change timers so the server reflects the final state the user saw.
  Object.keys(_qtyTimers).forEach(function(k){
    var entry = _qtyTimers[k];
    if (entry && entry.id) {
      clearTimeout(entry.id);
      if (typeof entry.fn === 'function') entry.fn();
    }
  });
  if (_cartTriggerEl && typeof _cartTriggerEl.focus === 'function') {
    _cartTriggerEl.focus();
    _cartTriggerEl = null;
  }
}

// ============================================================
// BOOT
// ============================================================
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}

})();
